import { motion } from "framer-motion";
import { cn } from "../../lib/utils";

type AnimatedSectionProps = {
  children: React.ReactNode;
  className?: string;

  /** Ativa o gradiente animado de fundo */
  animatedGradient?: boolean;

  /** Ativa o efeito de brilho (shine) */
  shine?: boolean;
};

const AnimatedSection = ({
  children,
  className,
  animatedGradient = true,
  shine = true,
}: AnimatedSectionProps) => {
  return (
    <motion.section
      initial={{ opacity: 0, y: -20, rotateX: -15 }}
      animate={{ opacity: 1, y: 0, rotateX: 0 }}
      transition={{ duration: 0.6, type: "spring" }}
      style={{ transformStyle: "preserve-3d" }}
      className={cn(
        "group relative bg-white/80 rounded-3xl p-8 shadow-2xl border border-slate-200/50 overflow-hidden",
        className,
      )}
    >
      {animatedGradient && (
        <motion.div
          aria-hidden
          animate={{
            backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
          }}
          transition={{ duration: 5, repeat: Infinity, ease: "linear" }}
          className="absolute inset-0 bg-gradient-to-r from-blue-500/5 via-blue-500/5 to-blue-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
          style={{ backgroundSize: "200% 200%" }}
        />
      )}

      {shine && (
        <motion.div
          aria-hidden
          className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
          animate={{ x: ["-200%", "200%"] }}
          transition={{
            duration: 3,
            repeat: Infinity,
            repeatDelay: 2,
            ease: "easeInOut",
          }}
          style={{ transform: "skewX(-20deg)" }}
        />
      )}

      <div className="relative z-10">{children}</div>
    </motion.section>
  );
};
export default AnimatedSection;
